import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MoneyService } from 'i2g-ng-utils';

@Pipe({
  name: 'money',
})
export class MoneyPipe implements PipeTransform {
  constructor(private _moneyService: MoneyService) {}

  /**
   * Format a value to money
   *
   * @param value {string | number} - should be in subunits
   * @param currencyCode {string} - Currency code
   * @param locale {string} - i
   */
  transform(
    value: any,
    currencyCode = 'USD',
    locale = 'en_US'
  ): string | Observable<string> {
    const hasValidParams = currencyCode && locale;

    if (value instanceof Observable) {
      return hasValidParams
        ? value.pipe(
            map((v) => this.formatInSuperUnit(v, currencyCode, locale))
          )
        : of('');
    }

    return hasValidParams
      ? this.formatInSuperUnit(value, currencyCode, locale)
      : '';
  }

  formatInSuperUnit(value: any, currencyCode: string, locale: string): string {
    const superUnit = this._moneyService.subToSuperUnit(value, currencyCode);

    return this._moneyService.format(superUnit, currencyCode, locale);
  }
}
